'use client';

import type { FunctionComponent } from 'react';
import { useEffectAsync } from '../../lib/hooks/useEffectAsync';
export const ShakeProvider: FunctionComponent = () => {
  useEffectAsync(async () => {
    if (process.env.NEXT_PUBLIC_SHAKE_ENABLED) return;
    const scriptId = 'shake-script';

    // Prevent adding multiple scripts
    if (document.getElementById(scriptId)) return;
    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'module';
    script.textContent = `
          import Shake from 'https://cdn.jsdelivr.net/npm/@shakebugs/browser@latest/+esm';
          window.Shake = Shake;
          Shake.start('BYvdElepMOFOjVuJVeHGzSJkc93p5hhsp7KVdKpIuM92jjfsR4n99ju');
        `;
    document.body.appendChild(script);
  }, []);
  return null;
};